import React, { Component } from "react";
import { Customer } from "./domain/customer/Customer";

const OCContext = React.createContext<State>(undefined);

interface State {
  customer: Customer | null;
  setCustomer: (customer: Customer) => void;
}

class OCProvider extends Component<any, State> {
  constructor(props) {
    super(props);

    // @ts-ignore
    this.state = {
      customer: null
    };
  }

  setCustomer(customer: Customer) {
    this.setState({ customer });
  }

  render() {
    return (
      <OCContext.Provider
        value={{
          customer: this.state.customer,
          setCustomer: this.setCustomer.bind(this)
        }}
      >
        {this.props.children}
      </OCContext.Provider>
    );
  }
}

export default OCContext;

export { OCProvider };
